export const UniqueProductLabelId = {
    "FEATURED": 1,
    "PREORDER_ONLY": 3
}